<!-- 处理班组 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('班组名称')">
              <a-input :placeholder="$t('请输入班组名称')" v-model="queryParam.teamName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('tickets')">{{ $t('导出') }}</a-button>
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :customRow="customRow"
        :rowSelection="{type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap fixed-height"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <div style="margin-top: 50px;" v-if="dataSource1.length>0">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns1"
        :dataSource="dataSource1"
        :loading="loading"
        class="j-table-force-nowrap fixed-height"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail1(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>

    <ProcessingTeamModal ref="modalForm" @ok="loadData"></ProcessingTeamModal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import ProcessingTeamModal from './ProcessingTeamModal'

  export default {
    name: 'ProcessingTeam',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      ProcessingTeamModal
    },
    data () {
      return {
        url: {
          list: "/jeecg-engineering/ticket/ticketsTeam/list",
          delete: "/jeecg-engineering/ticket/ticketsTeam/delete",
          deleteBatch: "/jeecg-engineering/ticket/ticketsTeam/deleteBatch",
          exportXlsUrl: "/jeecg-engineering/ticket/tickets/exportXls",
          importExcelUrl: "jeecg-engineering/ticket/tickets/importExcel",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          queryById: "/jeecg-engineering/ticket/ticketsTeam/queryById",
        },
        dictOptions:{},
        superFieldList:[],
        dataSource1:[],
      }
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // 表头
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('班组名称'),
            align:"center",
            dataIndex: 'teamName'
          },
          {
            title: this.$t('班组介绍'),
            align:"center",
            dataIndex: 'teamIntroduce',
          },
          {
            title: this.$t('组长名称'),
            align:"center",
            dataIndex: 'leaderName'
          },
          {
            title: this.$t('组长联系方式'),
            align:"center",
            dataIndex: 'leaderPhone'
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      // 表头
      columns1() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('组员姓名'),
            align:"center",
            dataIndex: 'userName'
          },
          {
            title: this.$t('组员电话'),
            align:"center",
            dataIndex: 'userPhone'
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },
        ]
      },
    },
    methods: {
      // 上面选择
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        this.ipagination1 = this.$options.data.call(this).itemIpagination;
        if (this.selectedRowKeys.length == 0) {
          this.dataSource1 = []
          return;
        }
        getAction(this.url.userList).then(res=>{
          if(res.success){
            let list = res.result.records;
            getAction(this.url.queryById,{id:selectedRowKeys[0]}).then(resp=>{
              if(resp.success){
                this.dataSource1 = list.filter(l=>resp.result.inspectionTeamUserIds.some(id=>id == l.userId));
              }
            })
          }
        });
      },
      customRow (record, index) {
        return {
          on:{
            click:(e)=>{debugger
              this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
              getAction(this.url.userList).then(res=>{
                if(res.success){
                  let list = res.result.records;
                  getAction(this.url.queryById,{id:this.selectedRowKeys[0]}).then(resp=>{
                    if(resp.success){
                      this.dataSource1 = list.filter(l=>resp.result.inspectionTeamUserIds.some(id=>id == l.userId));
                    }
                  })
                }
              });
            }
          }
        }
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>